import { FONT_STYLE } from '../groups.js';

var strike = {
    inclusive: true,
    group: FONT_STYLE,
    parseDOM: [
        { tag: 'strike' },
        { tag: 's' },
        { tag: 'del' },
        {
            style: 'text-decoration',
            getAttrs: function (value) { return value === 'line-through' && null; },
        },
    ],
    toDOM: function () {
        return ['s'];
    },
};

export { strike };



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/node_modules/@atlaskit/adf-schema/dist/esm/schema/marks/strike.js